import React, { useState, useEffect } from 'react'
import { RepaymentSchedule, getstatementcharges, getdata, checkrepaymentschedulestatus } from '../../Global/Index';
import { toast } from 'react-toastify';
import BeatLoader from 'react-spinners/BeatLoader';
import { useTheme } from '@mui/material';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { TbSend } from 'react-icons/tb';
const apiurl = process.env.REACT_APP_API_URL;


const override = {
  margin: "0 auto",
  marginLeft: '.3vw'
};

function Repayment_Schedule() {


  const [submitloader, setSubmitloader] = useState(false);
  const [loanAccountNumber, setLoanAccountNumber] = useState(null);
  const theme = useTheme()
  const navigate = useNavigate();

  useEffect(() => {
    const getData = async () => {
      const data = await getdata();
      if (data.response.status == '200') {
        setLoanAccountNumber(data.response.data.LoanAccountNumber);
      }
    }
    getData();
  }, [])




  const handleSubmit = async () => {
    try {
      setSubmitloader(true);
      const rescheduleCharge = await getstatementcharges();
      if (rescheduleCharge.response.status !== "200") {
        toast.error('Failed to retrieve statement charges. Please try again later.');
        setSubmitloader(false);
        return;
      }

      const charge = rescheduleCharge.response.data.repaymentScheduleCharge;
      if (charge == null) {
        toast.error('Charge is null. Please try again later.');
        setSubmitloader(false);
        return;
      }

      const repaymentschedulestatus = await checkrepaymentschedulestatus();

      if (repaymentschedulestatus.response.status !== "200" || !repaymentschedulestatus.response.data[0].allowreplayment) {
        window.location.href = '/success/All-Service-Request';
        return;
      }

      const resp = await RepaymentSchedule(charge);
      handleRepaymentResponse(resp);
      setSubmitloader(false);

      // Record service data after processing response
      const individualdata = repaymentschedulestatus.response.data[0]; // have to check only first data. updated: 7/05/2025(logic by himanshu sir)
      const repaymentDatas = { "ServiceName": "Repayment Schedule", "allowedServicesList": true, "allowreplayment": individualdata.allowreplayment }
      axios.post(`${apiurl}/record_As_data`, repaymentDatas, {
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json',
        }
      })
        .then(response => {
          console.log(response.data);
        })
        .catch(error => {
          console.error(error);
        });

    } catch (error) {
      console.error('Error in handleSubmit:', error);
      toast.error('An error occurred while processing your request.');
      setSubmitloader(false);
    }
  };

  const handleRepaymentResponse = (resp) => {
    if (resp.response.status == "200" && resp.response.message === 'Success') {
      toast.success('Request has been successfully submitted');
    } else if (resp.response.status === "419") {
      navigate('/Session-Expired');
    } else if (resp.response.status === "500") {
      toast.error('Something went wrong. Please try again later!')
    } else if (resp.response.status === "503") {
      toast.warn(resp.response.message);
    } else if (resp.response.status === "401") {
      window.location.href = '/';
    }
  };



  return (
    <>
      {
        <div className="Repayment_Schedule">
          <h3>Repayment Schedule</h3>
          <p>For Loan A/C : <span style={{ color: 'red' }}>{loanAccountNumber}</span></p>
          <button
            type="submit"
            onClick={handleSubmit}
            className='downloadbutton'
            disabled={submitloader}
            style={{
              margin: '1vw auto',
              background: theme.palette.maincolor.buttoncolor,
              color: theme.palette.maincolor.light,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '0.5rem'
            }}
          >
            {submitloader ? (
              <>
                <span>Processing</span>
                <BeatLoader
                  color="rgb(155,57,19)"
                  loading={submitloader}
                  cssOverride={override}
                  size={6}
                  aria-label="Loading Spinner"
                  data-testid="loader"
                />
              </>
            ) : (
              <>
                <TbSend size={20} />
                <span>Generate Now </span>
              </>
            )}
          </button>
        </div>

      }
    </>
  )
}

export default Repayment_Schedule